import React, { ReactNode, useId } from 'react';
import styles from './ConverterWidget.module.scss';
import typography from '@/styles/typography.module.scss';
import CurrencyInput from 'react-currency-input-field';
import { CurrencySelect } from '@/app/[lang]/buy-crypto/components/ConverterWidget/CurrencySelect';
import classNames from 'classnames';
import { Fiat } from '@/app/[lang]/buy-crypto/components/ConverterWidget/data';

const fiatSymbols: Record<Fiat, string> = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  CHF: '₣',
  AUD: 'AU$',
  CAD: 'CA$',
  TRY: '₺',
  NZD: 'NZ$',
  HKD: 'HK$',
  SGD: 'SG$',
  JPY: '¥',
};

type ConverterRowProps = {
  isFiat?: boolean;
  label: ReactNode;
  amount: string;
  options: string[];
  selectedOption: string;
  onSelectChange(value: string): void;
  onAmountChange(value: string): void;
  disabled?: boolean | undefined;
};

export const ConverterRow = ({
  isFiat = false,
  label,
  amount,
  options,
  selectedOption,
  onSelectChange,
  onAmountChange,
  disabled,
}: ConverterRowProps) => {
  const id = useId();

  return (
    <div className={styles.converterRow}>
      <label htmlFor={id} className={classNames(typography.subheadingML, styles.label)}>
        {label}
      </label>
      <div className={styles.inputGroup}>
        <div className={styles.inputWrapper}>
          <CurrencyInput
            id={id}
            className={styles.currencyInput}
            placeholder={'0'}
            prefix={isFiat ? fiatSymbols[selectedOption as Fiat] : undefined}
            decimalSeparator="."
            // intlConfig={{
            //   locale: locale,
            //   currency: isFiat ? selectedOption : undefined,
            // }} // problematic, has a bug when JPY yen selected
            disableGroupSeparators
            allowNegativeValue={false}
            decimalsLimit={isFiat ? 2 : 8}
            value={amount}
            onValueChange={(value) => onAmountChange(value ?? '')}
            disabled={disabled}
          />
        </div>

        <CurrencySelect
          options={options}
          value={selectedOption}
          onValueChange={onSelectChange}
          isFiat={isFiat}
        />
      </div>
    </div>
  );
};
